export const portfolioUploadQuery = {
  MODAL: 'portfolio-upload',
};
